import { useEffect, useRef } from 'react';
import './Stats.css';

const stats = [
  { number: '10+', label: 'Années\nd\'expérience' },
  { number: '200+', label: 'Projets\nlivrés' },
  { number: '3', label: 'Villes\nprincipales' },
  { number: '100%', label: 'Satisfaction\nclients' },
];

export default function Stats() {
  const countersRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate');
          }
        });
      },
      { threshold: 0.5 }
    );
    countersRef.current.forEach((el) => el && observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="stats">
      <div className="container stats__inner">
        {stats.map((stat, i) => (
          <div
            key={i}
            className="stats__item"
            data-aos="fade-up"
            data-aos-delay={i * 100}
            ref={(el) => (countersRef.current[i] = el)}
          >
            <span className="stats__number">{stat.number}</span>
            <span className="stats__label">{stat.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
